export default __webpack_public_path__ + "static/media/4.1.8d28ae0d.png";